export function facetOptionLabel(bucket) {
    return `${bucket._id} (${bucket.count})`;
}
export function facetOptionNameLabel(bucket) {
    return `${bucket.name} (${bucket.count})`;
}
//# sourceMappingURL=utils.js.map